import { RiskStudyDocumentType } from '@contexts/Estate';
const DetailsText = 'color: #6C757D; font-weight: 400';

type DocumentItem = {
  label: string;
  maxQuantity: number;
  acceptedFileTypes: string;
  order: number;
};

export const DocumentTypesAllowed: { [key in RiskStudyDocumentType]: DocumentItem } = {
  DNI: {
    label: `Foto de tu documento de identidad<span style="${DetailsText}"> por ambos lados. (sube hasta 2 archivos).</span>`,
    maxQuantity: 2,
    acceptedFileTypes: '.pdf,.doc,.docx, .jpg, .jpeg, .png',
    order: 1,
  },
  BANK_STATEMENT: {
    label: `Extractos bancarios<span style="${DetailsText}"> de los últimos 3 meses. (sube hasta 3 archivos).</span>`,
    maxQuantity: 3,
    acceptedFileTypes: '.pdf,.doc,.docx',
    order: 2,
  },
  RENT_DECLARATION: {
    label: `Declaración de renta<span style="${DetailsText}"> del último año que declaraste.</span>`,
    maxQuantity: 1,
    acceptedFileTypes: '.pdf,.doc,.docx',
    order: 3,
  },
  EMPLOYMENT_CERTIFICATION: {
    label: `Certificado laboral<span style="${DetailsText}"> con menos de un mes de antigüedad y que incluya salario.</span>`,
    maxQuantity: 1,
    acceptedFileTypes: '.pdf,.doc,.docx',
    order: 4,
  },
  RUT: {
    label: `RUT<span style="${DetailsText}"> con menos de un mes de antigüedad.</span>`,
    maxQuantity: 1,
    acceptedFileTypes: '.pdf,.doc,.docx',
    order: 5,
  },
  INCOME_CERTIFICATION: {
    label: `Comprobación de ingresos:<span style="${DetailsText}"> estos pueden ser contratos, cuentas de cobro, facturas, etc.</span>`,
    maxQuantity: 1,
    acceptedFileTypes: '.pdf,.doc,.docx',
    order: 6,
  },
  PENSION_CERTIFICATION: {
    label: `Certificado pensional.`,
    maxQuantity: 1,
    acceptedFileTypes: '.pdf,.doc,.docx',
    order: 7,
  },
  CHAMBER_OF_COMMERCE: {
    label: `Cámara de comercio<span style="${DetailsText}"> de los últimos 3 meses.</span>`,
    maxQuantity: 1,
    acceptedFileTypes: '.pdf,.doc,.docx',
    order: 8,
  },
  SIGNED_FINANCIAL_STATUS: {
    label: `Estados financieros firmados<span style="${DetailsText}"> de los últimos dos años.</span>`,
    maxQuantity: 1,
    acceptedFileTypes: '.pdf,.doc,.docx',
    order: 9,
  },
};
